import type {ComboboxOption} from 'common/components/combobox_input';

enum SubmissionSource {
  TheLoop = 'the-loop',
  UserDashboard = 'user-dashboard',
}

type TakeHomeFile = {
  id: string;
  name: string;
  size: number;
  s3Key: string;
  category: 'instructions' | 'solution' | 'data' | 'unknown';
  uploading: boolean;
  error: string | null;
};

type SubmissionFlowConfig = {
  allowQuestions?: boolean;
  allowTakeHome?: boolean;
  forceTakeHomeOnly?: boolean;
  allowDiaform?: boolean;
  allowStructuredQuestions?: boolean;
};

type SubmissionFlowData = {
  company: ComboboxOption | null;
  position: ComboboxOption | null;
  customDate: string;
  location: string;
  outcome: Outcome | null;
  experience: string;
  questions: string;
  takeHomeFiles: TakeHomeFile[];
};

type InterviewExperience = {
  id: string;
  outcome: string | null;
  outcome_color: 'green' | 'yellow' | 'red' | null;
  position_display_name: string | null;
  preview: string;
  date: string;
  body: string | null;
  prep_tip: string | null;
  interview_date: string;
  company_name: string;
  company_slug: string;
  position_name: string;
  position_slug: string;
  is_locked: boolean;
};

type ListedCompany = {
  mode: 'listed';
  slug: string;
};
type UnlistedCompany = {
  mode: 'unlisted';
  name: string;
};
type ListedPosition = {
  mode: 'listed';
  slug: string;
};
type UnlistedPosition = {
  mode: 'unlisted';
  name: string;
};

type OutcomeColor = 'green' | 'yellow' | 'red';
type Outcome = 'got-offer' | 'rejected' | 'withdrew' | 'waiting-reply';

type TakeHomeFileSubmission = {
  filename: string;
  s3_key: string;
  category: TakeHomeFile['category'];
};

type InterviewExperienceSubmitData = {
  outcome: string;
  outcome_color: OutcomeColor;
  position: ListedPosition | UnlistedPosition;
  /** Absolute date in YYYY-MM-DD format (relative dates are resolved before submission). */
  date: string;
  company: ListedCompany | UnlistedCompany;
  /** Experience narrative (step 2). */
  experience: string;
  /** Interview questions (step 3). */
  questions: string;
  location: string;
  take_home_files: TakeHomeFileSubmission[];
  submission_flow_id: string;
  /** Optional: slug of the guide this experience is linked to, used for backend unlock tracking. */
  guide_slug: string;
  source?: SubmissionSource;
};

export {SubmissionSource};
export type {
  InterviewExperience,
  InterviewExperienceSubmitData,
  TakeHomeFileSubmission,
  Outcome,
  OutcomeColor,
  SubmissionFlowData,
  SubmissionFlowConfig,
  TakeHomeFile,
};
